import gsap from 'gsap'
const listitems = gsap.utils.toArray('.list li');
let staggerItems = []
listitems.forEach((item, index) => {
    let icon = item.querySelector('.list__icon-in')
    let label = item.querySelector('.list__name')
    if(icon) staggerItems.push(icon)
    if(label) staggerItems.push(label)
})
// appear
let menuTrigger = document.querySelector('.js-menu')
let menuActive = false
menuTrigger.addEventListener('click', ()=>{
    if(menuActive){
        // HIDE MENU
        menuActive = false
        let tl = gsap.timeline({
            onComplete: ()=>{
                gsap.set('.menu',{autoAlpha:0})
            }
        })

        tl.to('.header__menu-label-hidden',{
            y: "-100%",
            duration: .5,
            ease: "power2.inOut",
        },0.)
        tl.fromTo('.header__menu-label-visible',{
            y: "100%",
        },{
            y: 0,
            duration: .5,
            ease: "power2.inOut",
        },0.5)

        tl.to('.wrap-scroll',{
            scale: 1,
            duration: 0.9,
            ease: 'power3.inOut',
        },0.1)

        tl.to('.menu__bg',{
            y:"100%",
            duration: 0.8,
            ease: 'power2.inOut',
            overwrite: true
        },0.)

        tl.to(staggerItems,{
            y: "100%",
            duration: 0.5,
            ease: "power2.inOut",
            overwrite: true
        },0.)

    } else{
        // SHOW MENU
        menuActive = true
        let tl = gsap.timeline({
            onStart: ()=>{
                gsap.set('.menu',{autoAlpha:1})
            }
        })

        tl.to('.header__menu-label-visible',{
            y: "-100%",
            duration: .5,
            ease: "power2.inOut",
        },0.)
        tl.fromTo('.header__menu-label-hidden',{
            y: "100%",
        },{
            y: 0,
            duration: .5,
            ease: "power2.inOut",
        },0.5)

        tl.to('.wrap-scroll',{
            scale: 0.95,
            duration: 1.3,
            ease: 'power3.inOut',
        },0)

        tl.to('.menu__bg',{
            y: 0,
            duration: 0.8,
            ease: 'power2.inOut',
            overwrite: true
        },0.2)
        tl.fromTo(staggerItems,{
            y: "100%",
            
        },{
            y: '0',
            stagger: 0.05,
            duration: 1,
            ease: "expo.out",
            overwrite: true
        },0.6)

    }

})


// mouseover

listitems.forEach((item, i) => {
    let preview = item.querySelector('.list__preview');
    let img;
    if(preview) img = preview.querySelector('img');
    
    item.addEventListener('mouseenter', () => {
        // gsap.set(preview, {autoAlpha: 1})
        listitems.forEach(it=>{
            it.classList.add('is-nothovered')
        })
        item.classList.add('is-hovered')
        item.classList.remove('is-nothovered')
        let tl = gsap.timeline()
        tl.to(preview,{autoAlpha:1,duration: 0.2})
        tl.to(preview, {
            scale: 1.1,
            ease: "power2.out",
            duration: .6,
        },0)
        tl.from(img,{
            scale: 2,
            ease: "power3.out",
            duration: .6
        },0)
    })

    item.addEventListener('mouseleave', () => {
        listitems.forEach(it=>{
            it.classList.remove('is-nothovered')
        })
        item.classList.remove('is-hovered')
        gsap.set(preview, {
            scale: 1,
            overwrite: true,
            autoAlpha: 0
        })
    })
})